import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const meterMaintenanceService = {
  fetchWithPivot: async (params = {}) => {
    const response = await axiosInstance.get('/meter-maintenance-cost/with-pivot', {
      params,
    })
    return response.data
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/meter-maintenance-cost/paginate', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
      const response = await axiosInstance.get('/meter-maintenance-cost/' + id)
    return response.data
  },
  store: async (data) => {
      const response = await axiosInstance.post('/meter-maintenance-cost', data)
      return response.data
  },
  storeWithCategory: async (data) => {
      const response = await axiosInstance.post('/meter-maintenance-cost/store-with-category', data)
      return response.data
  },
  update: async (data) => {
      const response = await axiosInstance.put(`/meter-maintenance-cost/${data.id}`, data)
      return response.data
  },
  updateWithCategory: async (data) => {
      const response = await axiosInstance.put(`/meter-maintenance-cost/${data.id}/with-category`, data)
      return response.data
  },
  delete: async (id) => {
      const response = await axiosInstance.delete(`/meter-maintenance-cost/${id}`)
      return response.data
  },
}